import React, { Component } from 'react'
import { any, func } from 'prop-types'
import styles from './CompleteChallengePopup.styl'

export default class CompleteChallengePopup extends Component {

	static propTypes = {
		name: any,
		submit: func
	}
	constructor(props) {
		super(props)
		this.state = { distance: '', time: '' }
	}
	handleChange(name, value) {
		this.setState(prevState => {
			const newState = { ...prevState }
			newState[name] = value
			return newState
		})
	}
	render() {
		const { distance, time } = this.state
		const { submit } = this.props
		return (
			<div className={ styles['main-container'] }>
				<form
					onSubmit={ (e) => {
						e.preventDefault()
						submit(distance, time)
					} }
				>
					<div className={ styles['container'] }>
						<h4>{ this.props.name }</h4>
						<div className={ styles['input-container'] }>
							<div className={ styles['input-box'] }>
								<p>Distancia Realizada</p>
								<input type="number" placeholder="Distância" value={ distance } onChange={ (e) => this.handleChange('distance', parseFloat(e.target.value)) } />
							</div>
							<div className={ styles['input-box'] }>
								<p>Tempo Realizado</p>
								<input type="number" placeholder="Tempo" value={ time } onChange={ (e) => this.handleChange('time', parseInt(e.target.value, 10)) } />
							</div>
						</div>
					</div>
					<input type="Submit" defaultValue="Guardar" className={ styles['form-submit'] } />
				</form>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/CompleteChallengePopup/CompleteChallengePopup.js